export const GET_CONTRACTS_LISTING = "GET_CONTRACTS_LISTING";
export const GET_CONTRACTS_DETAIL = "GET_CONTRACTS_DETAIL";
export const GET_CHANGE_ORDER_DOCUMENT = "GET_CHANGE_ORDER_DOCUMENT";
export const GET_CONTRACT_DETAIL_BY_ID = "GET_CONTRACT_DETAIL_BY_ID";
